/* Roles are explicitly assigned a group of reports.

   The rules for role-based access in this file are the following:

   1.  An empty object indicates that all of the reports in the group are assigned without exclusions.
   2.  Exclusions to the report list are explicitly stated in report list object.
   3.  If a report category (map growth or operational) does not exist for a role, they do not have any access to those
         reports.
   4.  If a role does not exist, they have no access to reports at all.

   5.  In one special case, a database value can be set for a district that will give ADMINISTRATOR access to 2 operational
         reports that normally an ADMINISTRATOR cannot see.  This is set with an 'additionalReportAccess' object and the
         reports to include.
 */

export const roleLevels = {
  none: 'NONE',
  district: 'DISTRICT',
  school: 'SCHOOL',
  teacher: 'TEACHER',
};

// ASSESSMENT_COORDINATOR === District Assessment Coordinator
export const roles = {
  ASSESSMENT_COORDINATOR: {
    mapGrowthReports: {},
    operationalReports: {
      excludeReports: 'studentsByDistrict',
    },
  },
  DATA_ADMINISTRATOR: { operationalReports: {} },
  ADMINISTRATOR: {
    mapGrowthReports: {
      excludeReports: 'dataExportScheduler,dataExportSchedulerBeta,districtLevelInsights',
    },
    additionalReportAccess: {
      includeOpsReports: 'studentsWithoutValidTestResults,testEventsByStatus',
    },
  },
  SCHOOL_ASSESSMENT_COORDINATOR: {
    mapGrowthReports: { excludeReports: 'districtLevelInsights' },
    operationalReports: {
      excludeReports:
        'instructorsWithoutClassAssignments,potentialDuplicateProfiles,profilesWithSharedIDs,userRoles,studentsByDistrict',
    },
  },
  INSTRUCTIONAL_PROVIDER: {
    mapGrowthReports: {
      excludeReports:
        'districtSummary,grade,projectedProficiencySummary,studentGrowthSummary,gradeBreakdown,dataExportScheduler,dataExportSchedulerBeta,recoveryGoalSetting,schoolLevelInsights,districtLevelInsights',
    },
  },
};

export const rolesWhichAllowFilters = [
  { roles: ['ASSESSMENT_COORDINATOR'], level: roleLevels.district },
  {
    roles: ['ADMINISTRATOR', 'SCHOOL_ASSESSMENT_COORDINATOR'],
    level: roleLevels.school,
  },
  { roles: ['INSTRUCTIONAL_PROVIDER'], level: roleLevels.teacher },
];

export default {
  roleLevels,
  roles,
  rolesWhichAllowFilters,
};
